var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 504.19 705.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Monaco, Monaco;\n        font-size: 9.17px;\n        isolation: isolate;\n        letter-spacing: -.02em;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #435d79;\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: #435d79;\n        stroke-miterlimit: 10;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 492.57,
    y: 50.74,
    width: 1.07,
    height: 653.76
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 489.62,
    y: 703.96,
    width: 6.95,
    height: 1.07
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.29,454.26H69.23V54.46h231.06v399.8h0ZM70.55,452.95h228.43V55.78H70.55v397.17Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 184.11,
    y: 55.12,
    width: 1.32,
    height: 280.98
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M361.14,393.75h-62.16v-71.19l62.16,34.15v37.04ZM300.29,392.43h59.53v-34.94l-59.53-32.7v67.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.01,59.37h-1.32v-7.85H66.77v7.85h-1.32v-9.17h239.55v9.17h.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.15,703.66l-19.39-2.88.1-.65,38.4-258.91,19.39,2.87-.1.65-38.4,258.91h0ZM30.26,699.67l16.78,2.49,38.11-256.96-16.78-2.49-38.11,256.96h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M321.45,703.66l-.09-.65-38.4-258.91,19.39-2.87.09.65,38.4,258.91-19.39,2.87h0ZM284.44,445.2l38.11,256.96,16.78-2.49-38.11-256.96-16.78,2.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M337.58,684.78l19.79-15.16,9.96,13.58-26.28,20.52-313.35-.49-25.89-20.03,9.96-13.57,19.62,15.02.17.13h306.02ZM337.13,683.47H32.01l-20.5-15.71-11.51,15.69,27.25,21.09,314.02.49h.23l27.64-21.58-11.51-15.69-20.51,15.7h.01Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 92.05,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M93.11,356.97h-1.07v-10.63h1.07v10.63ZM93.11,335.7h-1.07v-10.63h1.07v10.63ZM93.11,314.44h-1.07v-10.63h1.07v10.63ZM93.11,293.17h-1.07v-10.63h1.07v10.63ZM93.11,271.9h-1.07v-10.63h1.07v10.63ZM93.11,250.63h-1.07v-10.63h1.07v10.63ZM93.11,229.37h-1.07v-10.63h1.07v10.63ZM93.11,208.1h-1.07v-10.63h1.07v10.63ZM93.11,186.83h-1.07v-10.63h1.07v10.63h0ZM93.11,165.56h-1.07v-10.63h1.07v10.63ZM93.11,144.29h-1.07v-10.63h1.07v10.63h0ZM93.11,123.03h-1.07v-10.63h1.07v10.63ZM93.11,101.76h-1.07v-10.63h1.07v10.63Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 269.02,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M270.09,362.97h-1.07v-10.87h1.07v10.87ZM270.09,341.24h-1.07v-10.87h1.07v10.87ZM270.09,319.51h-1.07v-10.87h1.07v10.87ZM270.09,297.78h-1.07v-10.87h1.07v10.87ZM270.09,276.05h-1.07v-10.87h1.07v10.87ZM270.09,254.32h-1.07v-10.87h1.07v10.87ZM270.09,232.59h-1.07v-10.87h1.07v10.87ZM270.09,210.86h-1.07v-10.87h1.07v10.87ZM270.09,189.13h-1.07v-10.87h1.07v10.87ZM270.09,167.4h-1.07v-10.87h1.07v10.87ZM270.09,145.67h-1.07v-10.87h1.07v10.87ZM270.09,123.94h-1.07v-10.87h1.07v10.87ZM270.09,102.21h-1.07v-10.87h1.07v10.87Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.93,
    y: 75.15,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M225.99,250.48h-1.07v-10.62h1.07v10.62ZM225.99,229.23h-1.07v-10.62h1.07v10.62ZM225.99,207.98h-1.07v-10.62h1.07v10.62ZM225.99,186.73h-1.07v-10.62h1.07v10.62ZM225.99,165.49h-1.07v-10.62h1.07v10.62ZM225.99,144.24h-1.07v-10.62h1.07v10.62ZM225.99,122.99h-1.07v-10.62h1.07v10.62ZM225.99,101.74h-1.07v-10.62h1.07v10.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M228.86,270.62l-3.94-3.94v-5.57h1.07v5.13l3.63,3.63-.76.76h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 234.68,
    y: 273.39,
    width: 1.07,
    height: 5.63,
    transform: "translate(-126.41 247.22) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 242.55,
    y: 281.38,
    width: 1.07,
    height: 5.35,
    transform: "translate(-129.66 255.15) rotate(-45.01)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M239.37,286.55l.04-1.07,5.27.19-.19-5.27,1.07-.04.23,6.42-6.42-.23h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "303.94 12.5 303.94 15.45 66.53 15.45 66.53 12.5 65.46 12.5 65.46 19.46 66.53 19.46 66.53 16.52 303.94 16.52 303.94 19.46 305.01 19.46 305.01 12.5 303.94 12.5"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 137.6,
    y: 75.67,
    width: 1.07,
    height: 5.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.6,240.37h1.07v10.62h-1.07v-10.62ZM137.6,219.12h1.07v10.62h-1.07v-10.62ZM137.6,197.88h1.07v10.62h-1.07v-10.62ZM137.6,176.63h1.07v10.62h-1.07v-10.62ZM137.6,155.38h1.07v10.62h-1.07v-10.62ZM137.6,134.13h1.07v10.62h-1.07v-10.62ZM137.6,112.88h1.07v10.62h-1.07v-10.62ZM137.6,91.64h1.07v10.62h-1.07v-10.62h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M137.6,260.5h1.07v10.23h-1.07v-10.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.31,356.71l62.16-34.15v71.19H8.31v-37.04ZM69.15,324.79l-59.53,32.7v34.94h59.53v-67.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M134.63,274.97l3.94-3.94v-5.57h-1.07v5.13l-3.63,3.63.76.76h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 125.47,
    y: 280.02,
    width: 5.63,
    height: 1.07,
    transform: "translate(-160.81 172.88) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 117.71,
    y: 288.06,
    width: 5.35,
    height: 1.07,
    transform: "translate(-168.79 169.6) rotate(-44.99)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M124.13,290.9l-.04-1.07-5.27.19.19-5.27-1.07-.04-.23,6.42,6.42-.23h0Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(488.05 43.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "50\u2019")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(180.56 8.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "26\u2019")), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "185.43 336.1 70.47 393.75 188.23 452.43 298.98 393.75 185.43 336.1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprint);
export default __webpack_public_path__ + "static/media/blueprint.2dfe55429faf896ee11dcf106f737710.svg";
export { ForwardRef as ReactComponent };